import styled from "styled-components";
import { Row, Col } from "../App.styles";
import { RowInfoContainer } from "../common/RowInfo/RowInfo.style";

export const PaymentForm = styled.form`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .col-lg-4 {
    justify-content: flex-end;
  }

  .StripeElement {
    width: 100%;
  }

  ${Col} {
    margin-bottom: 1.5rem;
  }
`;

export const PaymentCol = styled(Col)`
  border-bottom: 1px solid #bdbdbd;
  margin-right: 0.75rem;
  padding-bottom: 0.75rem;
`;

export const ImageCol = styled(Col)`
  @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
    justify-content: center;
    order: 2;
    width: 100%;
  }
`;

export const LibraryRow = styled(Row)`
  background-color: #539cc9;
  color: white;

  ${ImageCol} {
    position: relative;
  }

  img {
    margin-bottom: -118px;
    max-width: 100%;
    z-index: 1;
  }
`;

export const CaptionRow = styled(Row)`
  padding: 10% 10% 5% 10%;
  font-size: 1.125rem;

  @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
    padding-top: 125px;
  }
`;

export const LibraryCol = styled(Col)`
  flex-direction: column;
  align-items: flex-start;
  padding: 30px;

  h2 {
    text-transform: uppercase;
    margin-bottom: 0.5rem;
  }

  h4 {
    color: black;
    font-size: 1.125rem;
    margin-top: 40px;
    margin-bottom: 0.5rem;
  }

  strong {
    color: black;
    font-weight: normal;
  }

  p {
    margin-bottom: 1rem;
  }

  button,
  a.btn {
    margin-left: 1rem;
  }

  video {
    margin: 0 0 30px;
    max-width: 100%;
  }

  img + p {
    margin-top: 1rem;
  }

  @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
    align-items: center;
    order: 1;

    * {
      text-align: center;
    }
  }
`;

export const TagRow = styled(RowInfoContainer)`
  background-color: #4caf4c;
  color: white;
  font-size: 1.125rem;
  padding: 20px 30px;

  @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
    text-align: center;
  }
`;

export const TagListWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;

  @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
    margin-top: 1rem;
    justify-content: center;
  }
`;

export const Tag = styled.li`
  list-style-type: none;
  margin-right: 10px;
  background-color: rgba(255, 255, 255, 0.1);
  border: solid 1px rgba(255, 255, 255, 0.1);
  color: #fff;
  padding: 4px 10px;
  margin-bottom: 10px;
  border-radius: 3px;
  transition: all ease 0.5s;
`;
